import {useContext} from "react";
import {EligibilityContext} from "./eligibilityProvider";

export default function useEligibility() {
  const {info, hardRefresh} = useContext(EligibilityContext)
  return {info, hardRefresh}
}
